const normalizeSport = sport => (sport || '').toString().trim().toLowerCase();

export const getVideoFieldSport = video => {
  if (!video) return '';

  const field = video.field || {};
  return video.fieldSport
    || video.field_sport
    || video.sport
    || field.fieldSport
    || field.field_sport
    || field.sport
    || '';
};

export const isPickleballVideo = video => normalizeSport(getVideoFieldSport(video)) === 'pickleball';
